import "./Hero.css";
import { Link } from "react-router-dom";
export default function HeroSection() {
  return (
    <header className="hero">
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <p className="hero-sub">HELLO, NEW FRIEND!</p>

        <h1 className="hero-title">
          DINE WITH US <br /> BOOK A TABLE OR WALK IN
        </h1>


        <div className="hero-buttons">
          {/* <button className="hero-btn-outline">BOOK A TABLE</button> */}
          <a href="tel:+19022702572">
            <button className="hero-btn-outline">BOOK A TABLE</button>
          </a>

          <Link to="/menu">
            <button className="hero-btn-text">OPEN MENU</button>
          </Link>
        </div>

        {/* Slider Dots */}
        <div className="hero-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </header>
  );
}
